// Whether the intro animation will play on this page load (once per session).
export const introWillPlay = () => {
  if (typeof window === "undefined") return false;
  if (sessionStorage.getItem("aviah_intro_seen")) return false;
  return !window.matchMedia("(prefers-reduced-motion: reduce)").matches;
};

export const HERO_DELAY = introWillPlay() ? 3.0 : 0;
